export default __webpack_public_path__ + "static/media/morty.26c22d26.jpg";